require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/library/fn/object/set-prototype-of.js
// module id = 104
// module chunks = 0